// Shared constants for AI popup components
export const popupMinHeight = 720;
export const popupMaxHeight = '80vh';
export const popupWidth = 960;

// Header height used across AI components
export const headerHeight = 36;
